import { http } from '@/core/api';
const controller = 'solutions';

export function getActiveSolutions() {
  return http.get(`${controller}/all?active=true`);
}
